import { twMerge } from "tailwind-merge";
import type { BaseProps, ContainerProps } from "./types";

export type OverlayProps = BaseProps &
  ContainerProps & {
    onClose?: () => void;
  };

export const Overlay = ({ className, children, onClose, ...props }: OverlayProps) => {
  return (
    <div
      className={twMerge("fixed inset-0 z-[9999] flex justify-center items-center bg-black/50", className)}
      onClick={onClose}
      {...props}
    >
      {children}
    </div>
  );
};
